exports = module.exports = require("../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".DS__LanguageSelect__root,\n.DS__LanguageSelect__button,\n.DS__LanguageSelect__popup {\n  all: initial;\n  font-family: var(--font-family);\n}\n\n.DS__LanguageSelect__root {\n  display: inline-flex;\n  align-items: center;\n  -webkit-transform: translate(0);\n          transform: translate(0);\n}\n\n.DS__LanguageSelect__button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n}\n\n.DS__LanguageSelect__button_alone {\n    cursor: default;\n  }\n\n.DS__LanguageSelect__popup {\n  display: block;\n  padding-right: 14px;\n  padding-left: 14px;\n  margin-top: -10px;\n}\n\n@media (max-width: 767px) {\n\n.DS__LanguageSelect__popup {\n    padding: 6px;\n    margin: 0\n}\n  }\n", ""]);

// exports
exports.locals = {
	"root": "DS__LanguageSelect__root",
	"button": "DS__LanguageSelect__button",
	"popup": "DS__LanguageSelect__popup",
	"button_alone": "DS__LanguageSelect__button_alone"
};